import Route from 'cio/routes/base';

export default class LayoutsRoute extends Route {
  crumb() {
    return {
      name: 'Layouts',
      path: 'layouts',
      helpLabel: 'layouts',
      helpUrl: 'https://learn.customer.io/getting-started/3-layouts-and-customerio.html',
    };
  }
}
